import { TimeoutError } from '@wix/form-http-essentials';
import { loadTranslations } from '../../services/load-translations';
import { fetchForms } from './fetch-forms';
import { getLocaleDataset, getAddressTemplates, getFieldInitialData } from './load-forms';
import { getUserData } from './wix-code-api';
export const getInitialData = async ({ formIds, formKind, namespace, throwWhenFormMissing, language, localeDatasetLoader, httpClient, errorMonitor, additionalMetadata, wixCodeApi, errorHandler, environment, bi, appDefinitionId, withTimeout, panoramaClient })=>{
    const [formsById, translations, userData] = await Promise.all([
        withTimeout('fetchForms', (signal)=>fetchForms({
                formIds,
                formKind,
                namespace,
                httpClient,
                errorMonitor,
                throwWhenFormMissing,
                additionalMetadata,
                errorHandler,
                language,
                signal
            })),
        loadTranslations(language, errorMonitor),
        withTimeout('getUserData', (signal)=>appDefinitionId && httpClient ? getUserData(wixCodeApi, {
                appDefinitionId,
                httpClient,
                signal
            }) : Promise.resolve(undefined)).catch((error)=>{
            if (error instanceof TimeoutError) {
                panoramaClient?.logger().error('getUserData timed out', {
                    taskName: error.taskName,
                    timeoutMs: error.timeoutMs
                });
            } else {
                errorMonitor.captureException(error);
            }
            return undefined;
        })
    ]);
    const forms = Object.values(formsById).filter(Boolean);
    const [localeDataset, addressTemplates, fieldInitialData] = await Promise.all([
        getLocaleDataset({
            allForms: forms,
            language,
            localeDatasetLoader,
            errorMonitor
        }),
        withTimeout('getAddressTemplates', (signal)=>getAddressTemplates({
                forms,
                existingAddressTemplates: undefined,
                httpClient,
                errorHandler,
                excludeEcomAddress: true,
                signal
            })),
        withTimeout('getFieldInitialData', (signal)=>getFieldInitialData({
                forms,
                httpClient,
                errorHandler,
                wixCodeApi,
                environment,
                bi,
                signal
            }))
    ]);
    return {
        formsById,
        translations,
        localeDataset,
        addressTemplates,
        fieldInitialData,
        userData
    };
};

//# sourceMappingURL=get-initial-data.js.map